import { snapshot } from 'valtio'
import format from 'date-fns/format'

import { transactionsProxy } from '../../../../../shared/proxies/transactionsProxy'
import { executeTransactionsSearch } from '../../../../../shared/apiUtils/executeTransactionsSearch'
import { type FilterBoxProps } from '../../../../../shared/components/ui/filterBox/FilterBox'
import { PRETTY_TRANSACTION_TYPE } from '../../../../../shared/types/GlobalTranactionTypeEnum'

function clearStartDate (): void {
  transactionsProxy.filters.startDate = null
  void executeTransactionsSearch({ displayLoader: false })
}

function clearEndDate (): void {
  transactionsProxy.filters.endDate = null
  void executeTransactionsSearch({ displayLoader: false })
}

function clearTransactionTypes (): void {
  transactionsProxy.filters.transactionTypes = []
  void executeTransactionsSearch({ displayLoader: false })
}

export function determineFilterRow (): FilterBoxProps[] {
  const { filters } = snapshot(transactionsProxy)

  const finalFilters: FilterBoxProps[] = []

  if (filters.startDate) {
    finalFilters.push({ clearFunction: clearStartDate, label: 'Start Date', value: format(filters.startDate, 'yyyy-MM-dd') })
  }
  if (filters.endDate) {
    finalFilters.push({ clearFunction: clearEndDate, label: 'End Date', value: format(filters.endDate, 'yyyy-MM-dd') })
  }
  if (filters.transactionTypes?.length > 0) {
    const statusValues = filters.transactionTypes.map(type => PRETTY_TRANSACTION_TYPE[type])
    const statusValue = statusValues.join(', ')
    finalFilters.push({ clearFunction: clearTransactionTypes, label: 'Status', value: statusValue })
  }

  return finalFilters
}

export function clearTransactionFilters (): void {
  transactionsProxy.filters.transactionTypes = []
  transactionsProxy.filters.startDate = null
  transactionsProxy.filters.endDate = null
  transactionsProxy.filters.search = ''
  void executeTransactionsSearch({ displayLoader: false })
}
